import React from 'react';
import CustomCheckbox from "../General/customCheckbox";
import FormGroupSelectMultiple from "../formGroupSelectMultiple";
import FormGroupTextInput from "../formGroupTextInput";
import Tooltip from "../General/tooltip";

const AdvancedDisbursements = (props) => {
    let labelClassName;
    if(props.formData.shouldBeAbleToApply){
        if(props.formData.shouldProvideCaseUpdate){
            labelClassName = "solicitor-group__check_box-label--checked";
        }
        else {
            labelClassName = 'solicitor-group__check_box-label';
        }
    }
    else {
        labelClassName = 'solicitor-group__check_box-label--disabled';
    }
    return(
        <div className="form-horizontal">
            <CustomCheckbox
                name="shouldBeAbleToApply"
                checked={props.formData.shouldBeAbleToApply}
                label="Allow to apply for Advance Disbursements"
                _onChange={props._onChange}
            />
            <FormGroupSelectMultiple
                disabled={!props.formData.shouldBeAbleToApply}
                Name="advancedDisbursementsSelectedCaseTypes"
                HandleCheckedState={props._handleCheckedCaseTypes}
                HandleInputChange={props._handleMultipleCaseTypes}
                Label="Case Types"
                Required={false}
                Options={props.caseTypes.map(item => {return {name:item.name, id: item.id}})}
                LeftWrapper="col-sm-3"
                CenterWrapper="col-sm-8 formGroupSelectInput-select-wrapper"
                RightWrapper=""
                InputWrapper="col-sm-8 formGroup-textInput-input-wrapper"
            />
            {
                props.subCaseTypes.length > 0?
                    <FormGroupSelectMultiple
                        disabled={!props.formData.shouldBeAbleToApply}
                        Name="advancedDisbursementsSelectedSubCaseTypes"
                        HandleCheckedState={props._handleAdCheckedSubCaseTypes}
                        HandleInputChange={props._handleAdSelectedSubCaseTypes}
                        Label="Sub Case Types"
                        Required={false}
                        Options={props.subCaseTypes.map(item => {return {name:item.name, id: item.id}})}
                        LeftWrapper="col-sm-3"
                        CenterWrapper="col-sm-8 formGroupSelectInput-select-wrapper"
                        RightWrapper=""
                        InputWrapper="col-sm-8 formGroup-textInput-input-wrapper"
                    />
                    :
                    null
            }
            {
                props.formData.selectedCaseTypes.length > 0?
                    <div className="form-group">
                        <div className="col-sm-3">
                            <span>Expense Types</span>
                        </div>
                    </div>
                    :
                    null
            }
            {
                props.formData.selectedCaseTypes.map( (caseType, index) => {
                    return  <div key={index} className="form-group">
                        <div className="col-sm-3">
                            <span>{caseType.name}</span>
                        </div>
                        <div className="col-sm-8">
                            {
                                props.expenseTypes.map(item => {
                                    return <CustomCheckbox
                                        key={item.id}
                                        disabled={!props.formData.shouldBeAbleToApply}
                                        name={"shouldProvideCaseUpdate " + item.id + ' ' + caseType.id}
                                        checked={props.formData.checkedExpenseTypesPerCaseType[caseType.id][item.id]?
                                            props.formData.checkedExpenseTypesPerCaseType[caseType.id][item.id]
                                            :
                                            ''
                                        }
                                        label={item.name}
                                        _onChange={(evt) => props._handleAdvancedDisbursementsNumberOfWeeksCheckBoxes(item.id, evt.target.checked, caseType.id)}
                                    />
                                })
                            }
                        </div>
                    </div>
                })
            }
            <div className="form-group">
                <div className="col-sm-3">
                    <span className="applicationsAndPolicies-font">{"Provide case update before applying"}</span>
                </div>
                <div className="col-sm-1">
                    <input
                        id={"shouldProvideCaseUpdate"}
                        type="checkbox"
                        className={"solicitor-group__check_box"}
                        checked={props.formData.shouldProvideCaseUpdate}
                        name={'shouldProvideCaseUpdate'}
                        onChange={props._handleNumberOfWeeksCheckBox}/>
                    <label className={labelClassName} htmlFor="shouldProvideCaseUpdate"></label>
                </div>
                <div className="col-sm-7">
                    <input
                        disabled={!props.formData.shouldBeAbleToApply || !props.formData.shouldProvideCaseUpdate}
                        type="number"
                        min={0}
                        className="form-control formGroup-textInput-input"
                        placeholder={'Number of weeks before the case last was updated'}
                        name='numberOfWeeks' value={props.formData.numberOfWeeks}
                        onChange={props._handleAdNumberOfWeeksChange}/>
                </div>
                <div className="col-sm-1">
                    <Tooltip text={"Number of weeks since last case update"}/>
                </div>
            </div>
            <h4 className="solicitorGroup__advance-disbursements__amount-header">Advance Disbursement Auto Approval Settings</h4>
            <FormGroupTextInput
                Min={0.00}
                Disabled={!props.formData.shouldBeAbleToApply}
                InputWrapper="col-sm-8"
                Label="Min Amount"
                Type="number"
                Name="minDisbursementAmount"
                Value={props.formData.minDisbursementAmount}
                HandleInputChange={props._handleAmountChange}
                RightWrapper={"col-sm-1"}
                rightData={ <Tooltip text={"Minimum amount takes effect per advance disbursement request"}/>}
            />
            <FormGroupTextInput
                Min={props.formData.minDisbursementAmount?props.formData.minDisbursementAmount:0.00}
                Disabled={!props.formData.shouldBeAbleToApply}
                InputWrapper="col-sm-8"
                Label="Max Amount"
                Type="number"
                Name="maxDisbursementAmount"
                Value={props.formData.maxDisbursementAmount}
                HandleInputChange={props._handleAmountChange}
                RightWrapper={"col-sm-1"}
                rightData={ <Tooltip text={"Maximum amount takes effect per advance disbursement request"}/>}
            />
            <FormGroupTextInput
                Min={0.00}
                Disabled={!props.formData.shouldBeAbleToApply}
                InputWrapper="col-sm-8"
                Label="Aggregate Amount"
                Type="number"
                Name="maxAggregatedDisbursementAmount"
                Value={props.formData.maxAggregatedDisbursementAmount}
                HandleInputChange={props._handleAmountChange}
                RightWrapper={"col-sm-1"}
                rightData={
                    <Tooltip
                        text={"Aggregate amount takes into account the "
                        + "firm total approved advance disbursements requests in calendar year"}
                    />
                }
            />
        </div>
    )
};

export default AdvancedDisbursements;